import { Theme } from '@mui/material'

/**
 * Suite à un retour du RANI (Réseau d'accessibilité) :
 *
 * Material-UI utilise un fieldset pour son style prédéfini,
 * mais il n'est parent d'aucun input :
 * son usage est donc illégitime et non accessible
 *
 * Donc on le supprime via le slot "notchedOutline" (voir le theme).
 *
 * Cependant, ce n'est pas suffisant, car cela casse la liste des options des Autocomplete
 * et on perd le style qui va avec.
 * Cette fonction génère le style nécessaire aux TextFields et Autocomplete pour garder
 * ce "contour gris" */
export default function sxInputRootGenerator(focused: boolean) {
  return (theme: Theme) => ({
    borderRadius: '4px',
    borderStyle: 'solid',
    ...(focused
      ? {
          borderColor: theme.palette.secondary.main,
          borderWidth: '2px'
        }
      : {
          borderColor: 'rgba(0, 0, 0, 0.23)',
          borderWidth: '1px',
          '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.87)'
          }
        })
  })
}
